export const getUser = async service => {
  const user = await service.get("/user/profile");
  return user;
};

export const getAttributes = location => {
  const titles = {
    "/admin": "Dashboard",
    "/admin/organizations": "Organizations",
    "/admin/activity": "Activity",
    "/admin/user-password": "User Password",
  };

  const orgName =
    location.state && location.state.org ? location.state.org.name : null;

  return {
    title: orgName || titles[location.pathname],
    enableBack: orgName != null
  };
};
